import { createApp } from 'vue'
import App from './App.vue'
import router from './router' 
import '@fortawesome/fontawesome-free/css/all.css'
import './assets/css/tailwind.css'; 
import Print from 'vue3-print-nb'
import { initShopOptions } from './utils/shopOptions'

// 导入移动端模块
import mobileModule, { mobileRouter, mobileUtils, initMobile } from './mobile'

// 初始化移动端
initMobile()

// 将移动端路由添加到主路由
mobileRouter.getRoutes().forEach(route => {
  router.addRoute(route)
})

const app = createApp(App)

// 使用插件
app.use(Print)
app.use(router)
app.use(mobileModule, { router })

// 添加全局属性
app.config.globalProperties.$mobile = mobileUtils

// 添加设备检测
app.config.globalProperties.$isMobile = mobileUtils.isMobile()
app.config.globalProperties.$isTouchDevice = mobileUtils.isTouchDevice()

initShopOptions().finally(() => {
  app.mount('#app')
})
